<template>
    <!-- Partners start -->
    <div v-if="props.logos" class="row mt-4">
        <div v-for="item in datas" :key="item" class="col-lg-3 col-md-4 col-6 text-center py-4">
            <img :src="item" class="avatar avatar-client" alt="">
        </div><!--end col-->
    </div><!--end row-->

    <div v-else class="row justify-content-center">
        <div v-for="item in datas" :key="item" class="col-lg-2 col-md-2 col-6 text-center py-4">
            <img :src="item" class="avatar avatar-client" alt="">
        </div><!--end col-->
    </div><!--end row-->


</template>

<script setup>
import { ref, defineProps } from 'vue'
import image from '../assets/images/client/amazon.png'
import image2 from '../assets/images/client/google.png'
import image3 from '../assets/images/client/lenovo.png'
import image4 from '../assets/images/client/paypal.png'
import image5 from '../assets/images/client/shopify.png'
import image6 from '../assets/images/client/spotify.png'

const props = defineProps({
    logos: {
        type: Boolean,
        required: true
    }
})
const datas = ref([image, image2, image3, image4, image5, image6])

</script>

<style lang="scss" scoped></style>